var exports = {
  "kL": "x620889e6--b4810a--container",
  "tX": "x620889e6--b4810a--title-container",
  "FR": "x620889e6--b4810a--button-container",
};

module.exports = exports;
